import { default as bfLogoDark } from './dark/bf.svg';
import { default as boLogoDark } from './dark/bo.png';
import { default as brLogoDark } from './dark/br.svg';
import { default as bsLogoDark } from './dark/bs.png';
import { default as caLogoDark } from './dark/ca.svg';
import { default as dkLogoDark } from './dark/dk.svg';
import { default as dkRealLogoLDark } from './dark/dk_real.svg';
import { default as fbLogoDark } from './dark/fb.svg';
import { default as fdLogoDark } from './dark/fd.svg';
import { default as fdRealLogoLDark } from './dark/fd_real.svg';
import { default as flLogoDark } from './dark/fl.svg';
import { default as fnLogoDark } from './dark/fn.svg';
import { default as hrLogoDark } from './dark/hr.svg';
import { default as klLogoDark } from './dark/kl.svg';
import { default as mgLogoDark } from './dark/mg.svg';
import { default as pbLogoDark } from './dark/pb.svg';
import { default as peLogoDark } from './dark/pe.svg';
import { default as pmLogoDark } from './dark/pm.svg';
import { default as ppLogoDark } from './dark/pp.svg';
import { default as shLogoDark } from './dark/sh.svg';
import { default as ssLogoDark } from './dark/sharp-sports.svg';
import { default as slLogoDark } from './dark/sl.svg';
import { default as stLogoDark } from './dark/st.svg';
import { default as tfLogoDark } from './dark/tf.svg';
import { default as udLogoDark } from './dark/ud.svg';
import { default as wbLogoDark } from './dark/wb.svg';
import { default as bfLogoLight } from './light/bf.svg';
import { default as boLogoLight } from './light/bo.png';
import { default as brLogoLight } from './light/br.svg';
import { default as bsLogoLight } from './light/bs.svg';
import { default as caLogoLight } from './light/ca.svg';
import { default as dkLogoLight } from './light/dk.svg';
import { default as dkRealLogoLight } from './light/dk_real.svg';
import { default as fbLogoLight } from './light/fb.svg';
import { default as fdLogoLight } from './light/fd.svg';
import { default as fdRealLogoLight } from './light/fd_real.svg';
import { default as flLogoLight } from './light/fl.svg';
import { default as fnLogoLight } from './light/fn.svg';
import { default as hrLogoLight } from './light/hr.svg';
import { default as klLogoLight } from './light/kl.svg';
import { default as mgLogoLight } from './light/mg.svg';
import { default as pbLogoLight } from './light/pb.svg';
import { default as peLogoLight } from './light/pe.svg';
import { default as pmLogoLight } from './light/pm.svg';
import { default as ppLogoLight } from './light/pp.svg';
import { default as shLogoLight } from './light/sh.svg';
import { default as ssLogoLight } from './light/sharp-sports.svg';
import { default as slLogoLight } from './light/sl.svg';
import { default as stLogoLight } from './light/st.svg';
import { default as tfLogoLight } from './light/tf.svg';
import { default as udLogoLight } from './light/ud.svg';
import { default as wbLogoLight } from './light/wb.svg';

export default {
	light: {
		ca: caLogoLight,
		dk: dkLogoLight,
		mg: mgLogoLight,
		pb: pbLogoLight,
		pp: ppLogoLight,
		pm: pmLogoLight,
		ss: ssLogoLight,
		wb: wbLogoLight,
		br: brLogoLight,
		bs: bsLogoLight,
		fd: fdLogoLight,
		hr: hrLogoLight,
		kl: klLogoLight,
		sh: shLogoLight,
		ud: udLogoLight,
		fb: fbLogoLight,
		bf: bfLogoLight,
		fl: flLogoLight,
		sl: slLogoLight,
		st: stLogoLight,
		tf: tfLogoLight,
		bo: boLogoLight,
		pe: peLogoLight,
		fn: fnLogoLight,
		fdReal: fdRealLogoLight,
		dkReal: dkRealLogoLight
	},
	dark: {
		ca: caLogoDark,
		dk: dkLogoDark,
		mg: mgLogoDark,
		pb: pbLogoDark,
		pp: ppLogoDark,
		pm: pmLogoDark,
		ss: ssLogoDark,
		wb: wbLogoDark,
		br: brLogoDark,
		bs: bsLogoDark,
		fd: fdLogoDark,
		hr: hrLogoDark,
		kl: klLogoDark,
		sh: shLogoDark,
		ud: udLogoDark,
		fb: fbLogoDark,
		bf: bfLogoDark,
		fl: flLogoDark,
		sl: slLogoDark,
		st: stLogoDark,
		tf: tfLogoDark,
		bo: boLogoDark,
		pe: peLogoDark,
		fn: fnLogoDark,
		fdReal: fdRealLogoLDark,
		dkReal: dkRealLogoLDark
	}
};
